module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAdklEQVRYR2O8Icf2nwEP0Hj0ixGfPCE5QuYzElIw6gBCQUypPMEooNQCQvoJOmA0DdA8BJDjCJYlKbUUV7xjMx+lkBl1wGgIjIbAaAiMhsBoCIyGwICEwGizfNCHAKFmNaXyBJvllFpASD9BB1DaQCUUxaMOAABLds/RP8tflwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/FISHERRECT_V.png
// module id = 5wdk
// module chunks = 18